import view from "../../views/pug.js";
import { router } from "../router/index.routes.js";
import { _user, _handler, Clip } from "../classes/index.classes.js";
import KTAPI from "../api/index.api.js";
import { ioSocket, ioPings } from "../mm/index.mm.js";

import { errorMsg } from "./offscreen.controller.js";
import { KTLang } from "../lang/lang.js";
import KTCookie, { get } from "../components/cookie.js";

let states = [
    "DEAD",
    "WARM",
    "START",
    "FH",
    "HT",
    "SH",
    "OT",
    "END"    
];

/*var clip = new ClipboardJS('.clip');
clip.on('success', function(e) {
    //console.log(e);
    //$('[data-toggle="popover"]').popover();
    $(e.trigger).popover();
    $(e.trigger).popover('show');
    setTimeout(() => {
        $(e.trigger).popover('hide');
    }, 1000);

});*/

let play = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        KTLang.update();
        let locs = await KTAPI.getSvPool();
        if(locs.message == 'done') {
            renderLocList(locs.res);
            renderSelectLocation(locs.res);
        }
        let servers = await KTAPI.getServers();
        
        if(servers.message == 'done' && servers.res.length > 0) { 
            renderLobbyList(servers.res);
            $("#lobby-list-loader").addClass("d-none");
            $("#lobby-cont-live").removeClass("d-none");
            $("#lobby-cont-wait").removeClass("d-none");
            reorderWaitingList();
        }
        else
        {
            $("#lobby-list-loader").addClass("d-none");
            $("#lobby-list-empty").removeClass("d-none");
        }
        
        $('.slider').slick({
            infinite: true,            
            //slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev btn btn-icon btn-light btn-active-light-primary position-absolute w-35px h-35px z-index-1" style="left:30px"><i class="bi bi-chevron-compact-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next btn btn-icon btn-light btn-active-light-primary position-absolute w-35px h-35px z-index-1" style="right:30px"><i class="bi bi-chevron-compact-right"></i></button>',
            variableWidth: true,
        });

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content'
};


$(document).ready(function(){

    _handler.on('ping', async (data) => {
        //console.log(data);
        //$(`[data-showping=${data.loc}]`).text(data.ping);
        if ($('.location-select').data('select2')) {
          
          //$('.location-select').trigger('change');
          reOrderLocOptions();
        } 
    });
    
    $(document).on("change", ".location-select",async function() {   
        var selectedVar = $(this).val();
        localStorage.setItem('app.location', JSON.stringify(selectedVar));
        if(selectedVar.length == 0)
        {
            $(".sv-lobby").removeClass("d-none");
        }
        else
        {
            $(`.sv-lobby[data-city]`).addClass("d-none");
            selectedVar.map(async city => {                
                $(`.sv-lobby[data-city=${city}]`).removeClass("d-none");
            });
        }
        
    });

    $(document).on("change", ".btn-check[name=grid]", async function(e) {
        let valueSelected = this.value;        
        
        let servers = await KTAPI.getServers();
        
        if(servers.message == 'done' && servers.res.length > 0) { 
            renderLobbyList(servers.res);
            $("#lobby-list-loader").addClass("d-none");
            $("#lobby-cont-live").removeClass("d-none");
            $("#lobby-cont-wait").removeClass("d-none");
            reorderWaitingList();
        }
        else
        {
            $("#lobby-list-loader").addClass("d-none");
            $("#lobby-list-empty").removeClass("d-none");
        }
    });
});

function reorderWaitingList()
{
    /*let parentDiv = $("#lobby-list-wait");
    let attributes = ["data-ping","data-players"];
    let mainAttribute = "data-players";
    let secondaryAttributes = ["data-ping"];
    let ascending = true;
    orderDivs(parentDiv, attributes, mainAttribute, secondaryAttributes, ascending);*/

    sortDivs("#lobby-list-wait", ["data-players", "data-ping"], [-1, 1]);
}

/**
 * 
 *  SOCKET.IO PROCESSESS
 * 
 */

const playSocket = (socket) => {
        
    socket.on("sv_update", async (data) => {

        //$(`#lobby-${data.lobby._id}`).find(".lobby-players-num").text(`${data.lobby.playersnum}/${parseInt(data.lobby.vs)*2}`);
        //console.log(data);
        updateLobby(data.sv);
        reorderWaitingList();

    });   
    
    
    socket.on('lobby-error', async (data) => {
        errorMsg({title:"Hey!",content:data.msg});return;
    });

};

export { playSocket };



/**
 * 
 *  RENDER FUNCTIONS
 * 
 */
const renderSelectLocation = (data) => {
    const getLocation = str => str.split(": ")[1];

    const locArray = localStorage.getItem('app.location') ? JSON.parse(localStorage.getItem('app.location')) : [];

    data.map(loc => {        
        let self = loc._id;
        /*let option = new Option(loc.region, loc.city, false, false);
        option.flag = self.flag;
        option.location = self.location;
        option.city = self.city;
        option.region = self.region;*/

        let option = /*html*/`<option class="location-option" value="${self.city}" data-flag="${self.flag}" data-city="${self.city}" data-region="${self.region}" data-location="${self.location}" data-regshort="${getLocation(self.region)}" data-ping="${ioPings[self.location] === undefined || ioPings[self.location].ping == 0 ? `9999` : ioPings[self.location].ping}">${self.location}</option>`;

        $(".location-select").append(option);
        $('.location-select').val(locArray).trigger('change');
    });


    $('.location-select').select2({
        placeholder: 'Selecciona una opción',
        allowClear: true,
        closeOnSelect: false,
        dropdownCssClass: 'location-select-dropdown',
        sorter: function(data) {
            return data.sort(function (a, b) {
                
                return Number($(`.location-option[data-location=${a.text}]`).attr("data-ping")) - Number($(`.location-option[data-location=${b.text}]`).attr("data-ping"));
            });
        },
        templateResult: function (data) {

            var region = $(data.element).attr('data-regshort');            

            if (data.id === '') { return data.text; }          
            var $option = $(
                `<span class="d-flex align-items-center justify-content-between pe-6">
                    <div class="d-flex align-items-center">            
                        <div class="w-20px me-2"><img class="w-100 h-auto" src="assets/media/flags/${$(data.element).attr("data-flag")}.gif"></div>
                        <span class="pt-1">${region}</span>
                    </div>
                    <div class="d-flex">
                        <span><i class="bi bi-bar-chart-fill text-success"></i> <span data-showping="${$(data.element).attr("data-location")}">${ioPings[$(data.element).attr("data-location")] === undefined || ioPings[$(data.element).attr("data-location")].ping == 0 ? `<div class="spinner-border text-primary text-center" role="status" style="width: 13px; height: 13px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[$(data.element).attr("data-location")].ping}</span></span>                
                    </div>
                </span>`
            );
        
            return $option;
        },
        templateSelection: function (data) {
          // No alterar las opciones que no son resultados
          if (data.id === '') { return data.text; }
      
          var $option = $(
            `<div class="d-flex">
                <div class="w-20px me-2"><img class="w-100 h-auto" src="assets/media/flags/${$(data.element).attr("data-flag")}.gif"></div>
                <span class="">${$(data.element).attr("data-city")}</span>
            </div>`
          );
      
          return $option;
        }
    });
}



const renderLobbyList = (data) => {
    
    let htmllive = [];
    let html = [];
    data.map(sv => {
        if(sv.live)
        {
            htmllive.push(renderLobby(sv));
        }else{
            html.push(renderLobby(sv));
        }
        
    });
    
    $("#lobby-list-live").html('').append(htmllive);
    $("#lobby-list-wait").html('').append(html);
    
    router.updatePageLinks();   
}

const renderLobby = (data) => {
    let cities = $('.location-select').val();
    let html = /* html */`
        <div id="sv-lobby-${data._id}" class="sv-lobby cursor-pointer d-flex flex-column flex-sm-row bg-body rounded p-4 mb-4 ${cities.includes(data.city) || cities.length == 0 ? "" : "d-none"}" data-players="${data.act_players}" data-location="${data.location}" data-city="${data.city}" data-ping="${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? 9999: ioPings[data.location].ping}">
            <!--begin::Block-->                                                                                   
            <div href="server/${data.server}" data-navigo class="d-flex align-items-center me-0 me-sm-5 mb-4 mb-sm-0">
                <!--begin::Symbol-->
                <div class="position-relative w-100 w-sm-200px h-100px h-md-70px overflow-hidden rounded bgi-size-cover bgi-position-center lobby-map-bg" style="background-image:url('assets/media/maps/400px/${data.map}.jpg');">
                    <!--<img src="assets/media/maps/400px/${data.map}.jpg" class="rounded lobby-map-img" alt="" style="position: relative;top: 50%;transform: translate(-50%,-50%);left: 50%;">-->
                    <span class="position-absolute badge badge-sm badge-light-primary bg-opacity-75 fs-small d-block lobby-map-name"  style="top: 50%;transform: translate(-50%,-50%);left: 50%;">${data.map}</span>
                </div>
                <!--end::Symbol-->                  
            </div>                                         
            <!--end::Block-->  

            <div href="server/${data.server}" data-navigo  class="d-flex flex-column h-100 flex-grow-1 mb-4 mb-sm-0">
                <!--begin::Header-->               
                <div class="me-0 me-sm-7">
                    <!--begin::Headin-->               
                    <div class="d-flex flex-stack mb-2 flex-wrap">
                        <span class="badge badge-sm border border-success flex-shrink-0 align-self-center text-gray-800 mb-2 mb-sm-0">PUG</span>
                        <!--begin::Title-->               
                        <div class="flex-shrink-0 mb-2 mb-sm-0">                            
                            <span class="fs-4 fw-bold text-white ${data.live ? "d-none" : ""}  lobby-tag lobby-nolive">${data.tag}</span>
                            <div class="${data.live ? "" : "d-none"} lobby-live"><span class="fs-3 fw-bold text-white lobby-namea me-2">${data.teamA_name == '' ? 'TEAM A' : data.teamA_name}</span> <span class="lobby-scorea fs-1 fw-bolder me-3 ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span> : <span class="lobby-scoreb fs-1 fw-bolder ms-3 ${data.scoreA < data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreB}</span> <span class="fs-3 fw-bold text-white lobby-nameb ms-2">${data.teamB_name == '' ? 'TEAM B' : data.teamB_name}</span></div>
                        </div>
                        <!--end::Title-->
                        <span class="badge badge-sm border border-primary flex-shrink-0 align-self-center text-primary lobby-state mb-2 mb-sm-0" data-i18n="play.${states[data.state]}"></span>
                    </div>
                    <!--end::Heading-->

                    <!--begin::Items-->               
                    <div class="d-flex align-items-center flex-wrap d-grid gap-2 justify-content-between">
                        <!--begin::Item-->                  
                        <div class="d-flex align-items-center me-5 me-xl-13">
                            <!--begin::Symbol-->
                            <div class="symbol symbol-30px me-3">
                                <span class="symbol-label bg-light-success">
                                    <i class="bi bi-geo-alt text-white"></i>
                                </span>
                            </div>
                            <!--end::Symbol--> 
                            
                            <!--begin::Info-->
                            <div class="m-0">                            
                                <span class="fw-semibold text-gray-500 d-block fs-8" data-i18n="play.region">Region</span>
                                <span class="fw-bold text-gray-800 fs-7">${data.region} <img class="ms-1" src="assets/media/flags/${data.flag}.gif"></span>
                            </div>
                            <!--end::Info-->
                        </div>                    
                        <!--end::Item-->

                        <!--begin::Item-->                  
                        <div class="d-flex align-items-center me-5 me-xl-13">
                            <!--begin::Symbol-->
                            <div class="symbol symbol-30px me-3">
                                <span class="symbol-label bg-light-success">
                                    <i class="bi bi-bar-chart-fill text-white"></i>
                                </span>
                            </div>
                            <!--end::Symbol--> 
                            
                            <!--begin::Info-->
                            <div class="m-0">                            
                                <span class="fw-semibold text-gray-500 d-block fs-8" data-i18n="play.ping">Ping</span>
                                <span class="fw-bold text-gray-800 fs-7" data-showping="${data.location}">${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? `<div class="spinner-border text-primary text-center" role="status" style="width: 11px; height: 11px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[data.location].ping}</span>
                            </div>
                            <!--end::Info-->
                        </div>                    
                        <!--end::Item--> 

                        <!--begin::Item-->                  
                        <div class="d-flex align-items-center">
                            <!--begin::Symbol-->
                            <div class="symbol symbol-30px me-3">
                                <span class="symbol-label bg-light-success">
                                    <i class="bi bi-person-video text-white"></i>
                                </span>
                            </div>
                            <!--end::Symbol--> 
                            
                            <!--begin::Info-->
                            <div class="m-0">                            
                                <span class="fw-semibold text-gray-500 d-block fs-8" data-i18n="play.players">Players</span>
                                <span class="fw-bold text-gray-800 fs-7"><span class="lobby-act-players text-dark fw-bolder fs-5">${data.act_players}</span>/${data.max_players}</span>
                            </div>
                            <!--end::Info-->
                        </div>                    
                        <!--end::Item-->
                    </div>
                    <!--end::Items-->
                </div>                                
                
            </div>
            
            <!--begin::Info-->
            <div class="d-flex align-items-center justify-content-between flex-wrap">                
                <button type="button" class="external-handler btn btn-outline btn-outline-dashed btn-color-muted btn-active-color-white btn-sm px-4 me-2 text-nowrap clip lobby-btn-ip ${data.live ? "d-none" : ""} lobby-nolive" data-clipboard-text="connect ${data.server}" i18n-label="example.copied_server" data-i18n="play.copyip">
                    Copy IP
                </button>
                <a href="steam://connect/${data.hltv}" target="_blank" class="external-handler btn btn-bg-info btn-color-zblack btn-active-color-white btn-sm px-4 me-2 text-nowrap lobby-btn-hltv ${data.live ? "" : "d-none"} lobby-live">
                    HLTV
                </a>
                <a href="steam://connect/${data.server}" class="external-handler btn btn-bg-primary btn-color-zblack btn-active-color-white btn-sm px-4 text-nowrap lobby-btn-connect ${data.act_players >= data.max_players ? "disabled" : ""}" data-i18n="play.connect">
                    Connect
                </a>
            </div>                                  
            <!--end::Info-->                                                      
        </div>
                `;

    let ahtml =  /*html*/ `
        <div id="sv-lobby-${data._id}" class="sv-lobby text-decoration-none text-reset ${cities.includes(data.city) || cities.length == 0 ? "" : "d-none"}" data-players="${data.act_players}" data-location="${data.location}" data-ping="${ioPings[data.location] === undefined || ioPings[data.location].ping == 0 ? 9999: ioPings[data.location].ping}">
            <div class="bg-body rounded text-color-gray-900 overflow-hidden w-100 min-h-150px d-flex mb-5" style="transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s;user-select:none;">
                <div href="server/${data.server}" data-navigo class="w-125px min-w-125px position-relative d-flex flex-column align-items-center justify-content-center bgi-size-cover bgi-position-x-center bgi-position-y-center cursor-pointer" style="background-color: rgb(37,37,37);background-image:linear-gradient(0deg, rgba(31, 31, 31, 0.88), rgba(31, 31, 31, 0.88) 100%), url('assets/media/maps/400px/${data.map}.jpg');">
                    <span class="badge badge-light-success badge-sm my-2 text-uppercase">${data.ac_required ? 'Ranked' : 'Non-Ranked'}</span>
                    <span class="m-0 fw-bolder fs-1 text-gray-800" style="letter-spacing:0em">
                        <div class="d-flex">                            
                            <span class="lobby-scorea fs-1 fw-bolder me-3 ${data.scoreA > data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreA}</span>
                            <div class="mx-2">-</div>
                            <span class="lobby-scoreb fs-1 fw-bolder ms-3 ${data.scoreA < data.scoreB ? "text-primary" : "text-gray-700"}">${data.scoreB}</span>
                        </div>
                    </span>

                </div>

                <div href="server/${data.server}" data-navigo class="d-flex flex-column flex-grow-1 min-w-1px cursor-pointer" style="-webkit-box-flex: 1;">
                    <div class="d-flex align-items-center px-3 py-2 w-100">
                        <div class="d-flex align-items-center">
                            <div class="me-1 d-none">
                                <div class="btn btn-icon">
                                    <!--<i class="fad fa-shield-check"></i>-->
                                    <!--begin::Svg Icon | path: /var/www/preview.keenthemes.com/keenthemes/metronic/docs/core/html/src/media/icons/duotune/general/gen048.svg-->
                                    <span class="svg-icon svg-icon-muted svg-icon-2hx"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor"/>
                                    <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                </div>
                            </div>
                            <span class="d-inline-flex m-0 fw-bold fs-7 lh-2 align-items-center gap-2" style="letter-spacing: 0.2px;">
                                <span><img class="ms-1" src="assets/media/flags/${data.flag}.gif"> ${data.region}</span><span>•</span><span>${data.tag}</span><span>•</span><span class="badge badge-light badge-sm text-uppercase me-2 mb-2">${data.ac_required ? 'Anticheat Required' : 'Anticheat Optional'}</span>
                            </span>
                        </div>
                    </div>
                    <div class="py-1 px-3 flex-grow-1">
                        <div class="d-flex flex-row">
                            <div class="d-flex flex-column gap-2 text-nowrap" style="flex-basis: 25%">
                                
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden d-flex flex-wrap pt-0 pb-2 px-3">
                        
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-center min-w-125px">
                    <div class="d-flex flex-column gap-2 align-items-center justify-content-center w-100 px-3">
                        <button type="button" class="external-handler btn w-100 btn-outline btn-outline-dashed btn-color-muted btn-active-color-white btn-sm text-nowrap clip lobby-btn-ip ${data.live ? "d-none" : ""} lobby-nolive" i18n-label="example.copied_server" data-clipboard-text="connect ${data.server}" data-i18n="play.copyip">
                        Copy IP</button>
                        <a href="steam://connect/${data.hltv}" target="_blank" class="external-handler btn w-100 btn-bg-info btn-color-zblack btn-active-color-white btn-sm text-nowrap lobby-btn-hltv ${data.live ? "" : "d-none"} lobby-live">
                            HLTV
                        </a>
                        <a href="steam://connect/${data.server}" class="external-handler btn btn-bg-primary w-100 btn-color-zblack btn-active-color-white btn-sm text-nowrap lobby-btn-connect ${data.act_players >= data.max_players ? "disabled" : ""}" data-i18n="play.connect">
                            Connect
                        </a>
                    </div>
                </div>

            </div>
        </div>
    `;
    
    if(parseInt($(".btn-check[name=grid]:checked").val()) == 1)
    {
        html = $(html);
    }
    else
    {
        html = $(ahtml);
    }

    html.localize();
    router.updatePageLinks();
    return html;
}

function updateLobby(data)
{
    //console.log(data._id);
    Object.keys(data).forEach(function(key, index) {
        if(key == 'map')
        {
            $("#sv-lobby-"+data._id).find(".lobby-map-img").attr("src", `assets/media/maps/400px/${data[key]}.jpg`);
            $("#sv-lobby-"+data._id).find(".lobby-map-bg").css("background-image", `url('assets/media/maps/400px/${data[key]}.jpg')`);
            $("#sv-lobby-"+data._id).find(".lobby-map-name").text(data[key]);        
        }
        if(key == 'act_players')
        {   
            $("#sv-lobby-"+data._id).attr("data-players", data[key]);         
            $("#sv-lobby-"+data._id).find(".lobby-act-players").text(data[key]);
            if(data[key] >= data.max_players)
            {
                $("#sv-lobby-"+data._id).find(".lobby-btn-connect").addClass("disabled");
            }
            else
            {
                $("#sv-lobby-"+data._id).find(".lobby-btn-connect").removeClass("disabled");
            }
        }
        if(key == 'state')
        {            
            //$("#sv-lobby-"+data._id).find(".lobby-state").text(states[data[key]]);
            $("#sv-lobby-"+data._id).find(".lobby-state").attr("data-i18n", "play."+states[data[key]]).localize();
        }

        if(key == 'scoreA' || key == 'scoreB' || key == 'teamA_name' || key == 'teamB_name')
        {
            $("#sv-lobby-"+data._id).find(".lobby-scorea").text(data.scoreA);
            $("#sv-lobby-"+data._id).find(".lobby-scoreb").text(data.scoreB);
            $("#sv-lobby-"+data._id).find(".lobby-namea").text(data.teamA_name == '' ? 'TEAM_A': data.teamA_name);
            $("#sv-lobby-"+data._id).find(".lobby-nameb").text(data.teamB_name == '' ? 'TEAM_B': data.teamB_name);
        }

        if(key == 'live')
        {
            if(data[key] == true){
                if(!$("#lobby-list-live").find("#sv-lobby-"+data._id).length && $("#lobby-list-wait").find("#sv-lobby-"+data._id).length)
                {
                    $("#sv-lobby-"+data._id).appendTo($("#lobby-list-live"));
                }
                
                $("#sv-lobby-"+data._id).find(".lobby-nolive").addClass("d-none");
                $("#sv-lobby-"+data._id).find(".lobby-live").removeClass("d-none");
            }
            if(data[key] == false){
                if($("#lobby-list-live").find("#sv-lobby-"+data._id).length && !$("#lobby-list-wait").find("#sv-lobby-"+data._id).length)
                {
                    $("#sv-lobby-"+data._id).appendTo($("#lobby-list-wait"));
                }

                $("#sv-lobby-"+data._id).find(".lobby-live").addClass("d-none");
                $("#sv-lobby-"+data._id).find(".lobby-nolive").removeClass("d-none");
            }
        }

        
    });
    $("#sv-lobby-"+data._id).localize();
    router.updatePageLinks();    
}

const renderLobbyToList = (data) => {

    let html = /* html */`
                <div id="lobby-${data._id}" class="d-flex py-4 px-6 bg-body rounded align-items-sm-center mb-5">
                    <!--begin::Symbol-->                    
                    <div class="position-relative w-250px h-80px overflow-hidden rounded me-5">
                        <img src="assets/media/maps/400px/${data.maps[0]}.jpg" class="rounded lobby-map-img" alt="" style="position: relative;top: 50%;transform: translate(-50%,-50%);left: 50%;">
                        <span class="position-absolute badge ${data.type == "pug" ? "badge-light-success" : "badge-light-info"} d-block text-uppercase me-3" style="top:8px;left:8px;">${data.type}</span>
                        <span class="position-absolute badge badge-light-dark d-block" style="top:8px;right:8px;">${data.vs}v${data.vs}</span>
                        <span class="position-absolute badge badge-sm badge-light-primary bg-opacity-75 fs-small d-block lobby-map-name"  style="top: 50%;transform: translate(-50%,-50%);left: 50%;">${data.maps[0]}</span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1 me-5">
                        <div class="d-flex flex-column h-100">
                            <div class="py-1 text-center">
                                <!--begin::Text-->
                                <!--<span class="fw-semibold text-gray-600 fs-6 d-block">Flat cartoony illustrations with vivid unblended colors and asymmetrical beautiful purple hair lady</span>-->
                                <span class="card-label fw-bolder text-dark text-truncate text-nowrap mw-150px mw-md-250px fs-6">${data.title}</span>
                                <!--end::Text-->
                                <!--begin::Stats-->
                                
                                <!--end::Stats-->
                            </div><!--begin::Header-->
                            <div class="py-1">
                                <!--begin::Headin-->
                                
                                <!--end::Heading-->
                                <!--begin::Items-->
                                <div class="d-flex align-items-center flex-wrap d-grid gap-2 justify-content-between">
                                    <!--begin::Item-->
                                    <div class="d-flex align-items-center me-5 me-xl-13">
                                        <!--begin::Symbol-->
                                        <div class="symbol symbol-40px me-3">
                                            <img src="${data.creatorInfo.avatar}" class="" alt="">
                                        </div>
                                        <!--end::Symbol-->
                                        <!--begin::Info-->
                                        <div class="m-0 w-80px text-nowrap text-truncate">
                                            <span class="fw-semibold text-gray-600 d-block fs-7">Host</span>
                                            <a href="user/${data.creatorInfo.communityid}" data-navigo class="fw-bold text-gray-800 text-hover-primary fs-7 dnickname"></a>
                                        </div>
                                        <!--end::Info-->
                                    </div>
                                    <!--end::Item-->

                                    <!--begin::Item-->
                                    <div class="d-flex align-items-center me-5 me-xl-13">                                
                                        <!--begin::Info-->
                                        <div class="m-0">
                                            <span class="fw-semibold text-gray-600 d-block fs-7">Players</span>
                                            <span class="text-gray-800 fw-bold fs-7 d-block text-start ps-0 lobby-players-num">${data.playersnum}/${parseInt(data.vs)*2}</span>
                                        </div>
                                        <!--end::Info-->
                                    </div>
                                    <!--end::Item-->

                                    <!--begin::Item-->
                                    <div class="d-flex align-items-center me-5 me-xl-13">                                
                                        <!--begin::Info-->
                                        <div class="m-0">
                                            <span class="fw-semibold text-gray-600 d-block fs-7">Region</span>
                                            <span class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><img src="assets/media/flags/${data.flag}.gif" class="h-15px me-2" alt="image">${data.region}</span>
                                        </div>
                                        <!--end::Info-->
                                    </div>
                                    <!--end::Item-->

                                    <!--begin::Item-->
                                    <div class="d-flex align-items-center me-5 me-xl-13">                                
                                        <!--begin::Info-->
                                        <div class="m-0">
                                            <span class="fw-semibold text-gray-600 d-block fs-7">Ping</span>
                                            <span class="text-gray-800 fw-bold fs-7 d-block text-start ps-0"><i class="bi bi-bar-chart-fill text-success fs-8"></i> <span data-showping="${data.location}">${_user.ping !== undefined && _user.ping[data.location] !== undefined ? _user.ping[data.location] : `<div class="spinner-border" style="width: 0.5rem; height: 0.5rem;" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                          </div>`}</span></span>
                                        </div>
                                        <!--end::Info-->
                                    </div>
                                    <!--end::Item-->
                                </div>
                                <!--end::Items-->
                            </div>
                            <!--end::Header-->
                            <!--begin::Body-->
                            
                            <!--end::Body-->
                            <!--begin::Footer-->
                            
                            <!--end::Footer-->
                        </div>
                    </div>
                    <!--end::Section-->
                    
                    <div class="text-end">
                        <a data-navigo href="match/${data._id}" class="btn btn-icon btn-light-primary btn-active-primary">
                            <i class="far fa-play-circle fs-2x"></i>
                        </a>
                    </div>
                    
                    
                </div>`;
    html = $(html);
    html.find(".dnickname").text(data.creatorInfo.nickname);
    $(".lobby-list").append(html);
    router.updatePageLinks();

};


function renderLocList(data){
    let html = [];
    data.map(loc => {
        html.push(renderLoc(loc));
    });
    
    $("#loc-list").html('');
    $("#loc-list").append(html);
    router.updatePageLinks();

    $("#loc-list").sortChildren((a, b) => parseInt($(a).attr("data-ping")) > parseInt($(b).attr("data-ping")) ? 1 : -1);
    setTimeout(() => {
        $("#loc-list").sortChildren((a, b) => parseInt($(a).attr("data-ping")) > parseInt($(b).attr("data-ping")) ? 1 : -1);
    }, 20000);

}

function renderLoc(data){
    
    let self = data._id;
    let html = '';

    html = /*html*/`
        <!--begin::Item--> 
        <li class="nav-item mb-3 me-3 me-lg-6" data-location="${self.location}" data-ping="${ioPings[self.location] === undefined || ioPings[self.location].ping == 0 ? 9999: ioPings[self.location].ping}">
            <!--begin::Link--> 
            <span class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden w-auto h-auto py-4 text-nowrap">
                <!--begin::Subtitle-->
                <span class="nav-text text-white fw-bold fs-6 lh-1 mb-1"><img class="me-1" style="float:left" src="assets/media/flags/${self.flag}.gif"> <span class="me-4">${self.flag.toUpperCase()}</span><i class="bi bi-bar-chart-fill text-success"></i> <span data-showping="${self.location}">${ioPings[self.location] === undefined || ioPings[self.location].ping == 0 ? `<div class="spinner-border text-primary text-center" role="status" style="width: 13px; height: 13px;"><span class="visually-hidden">Loading...</span></div>` : ioPings[self.location].ping}</span></span>                         
                <span class="nav-text text-gray-700 fw-bold fs-7 lh-1">${self.region}</span> 
                <!--end::Subtitle-->                                                
            </span>
            <!--end::Link-->
        </li>
        <!--end::Item--> 
    `;

    html = $(html);
    return html;
}

$.fn.sortChildren = function (sortingFunction) {

    return this.each(function () {
        const children = $(this).children().get();
        children.sort(sortingFunction);
        $(this).append(children);
    });

};


function orderDivs(parentDiv, attributes, mainAttribute, secondaryAttributes, ascending) {
    // Get the child div elements of the parent div
    let childDivs = parentDiv.children('div');
  
    // Sort the child divs based on the specified attributes
    childDivs.sort(function(a, b) {
      let aVal = parseInt($(a).attr(mainAttribute));
      let bVal = parseInt($(b).attr(mainAttribute));
      for (let i = 0; i < secondaryAttributes.length; i++) {
        let secondaryAttribute = secondaryAttributes[i];
        if (aVal === bVal) {
          aVal = parseInt($(a).attr(secondaryAttribute));
          bVal = parseInt($(b).attr(secondaryAttribute));
        } else {
          break;
        }
      }
      if (ascending) {
        if (aVal < bVal) {
          return -1;
        } else if (aVal > bVal) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (aVal < bVal) {
          return 1;
        } else if (aVal > bVal) {
          return -1;
        } else {
          return 0;
        }
      }
    });
  
    // Reorder the child divs in the parent div without creating new DOM elements
    $.each(childDivs, function(index, childDiv) {
      parentDiv.append(childDiv);
    });
  }

function sortDivs(parentSelector, attributes, order) {
    var $divs = $(parentSelector).children('div').detach();

    $divs.sort(function(a, b) {
        for (var i = 0; i < attributes.length; i++) {
        var attr = attributes[i];
        var aValue = $(a).attr(attr);
        var bValue = $(b).attr(attr);

        // Comprobar si los valores son números
        if (!isNaN(aValue) && !isNaN(bValue)) {
            aValue = Number(aValue);
            bValue = Number(bValue);
        }

        // Comparar los valores
        if (aValue < bValue) {
            return -1 * order[i];
        } else if (aValue > bValue) {
            return 1 * order[i];
        }
        }

        // Si llegamos a este punto, todos los atributos son iguales
        return 0;
    });

    // Reinsertar los divs en el div padre
    $(parentSelector).append($divs);
}

function reOrderLocOptions() {
    if($(".location-select-dropdown").length == 0) return;
    var $divs = $(".location-select-dropdown .select2-results__options").children('li').detach();
    var attributes = ["data-ping"];
    var order = [1];

    $divs.sort(function(a, b) {
        for (var i = 0; i < attributes.length; i++) {
        var attr = attributes[i];
        var aValue = $(a).find("[data-showping]").text();
        var bValue = $(b).find("[data-showping]").text();

        // Comprobar si los valores son números
        if (!isNaN(aValue) && !isNaN(bValue)) {
            aValue = Number(aValue);
            bValue = Number(bValue);
        }

        // Comparar los valores
        if (aValue < bValue) {
            return -1 * order[i];
        } else if (aValue > bValue) {
            return 1 * order[i];
        }
        }

        // Si llegamos a este punto, todos los atributos son iguales
        return 0;
    });

    // Reinsertar los divs en el div padre
    $(".location-select-dropdown .select2-results__options").append($divs);
}



export default play;